import * as React from 'react';

function SvgCheckEmpty(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.97 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M23.99 4.91V19.1a4.92 4.92 0 01-4.92 4.89H4.91a4.7 4.7 0 01-3.47-1.44A4.71 4.71 0 01-.01 19.1V4.91a4.75 4.75 0 011.45-3.47A4.77 4.77 0 014.91-.01h14.16a4.77 4.77 0 013.47 1.44 4.75 4.75 0 011.45 3.48zm-4.92-2.72H4.91a2.62 2.62 0 00-1.92.8 2.64 2.64 0 00-.8 1.92V19.1a2.62 2.62 0 00.8 1.89 2.62 2.62 0 001.93.8h14.15a2.73 2.73 0 002.73-2.72V4.91a2.64 2.64 0 00-.81-1.92 2.62 2.62 0 00-1.92-.8z" />
    </svg>
  );
}

const MemoSvgCheckEmpty = React.memo(SvgCheckEmpty);
export default MemoSvgCheckEmpty;
